import React from "react";
import { useTranslation } from "react-i18next";
import { moduleText as ui } from "../i18n/moduleText";

function RecoveryMessage() {
  useTranslation();
  return (
    <main role="alert" style={{ maxWidth: 600, margin: "3rem auto", padding: 24 }}>
      <h1>{ui("This page could not be opened.")}</h1>
      <p>{ui("Check your connection, then reload this page. Your saved work is still available.")}</p>
      <button type="button" onClick={() => window.location.reload()}>{ui("Reload page")}</button>
      <p><a href="/">{ui("Return to Today")}</a></p>
    </main>
  );
}

// A failed module download must offer a way forward instead of a blank screen.
export default class RouteLoadBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  render() {
    return this.state.failed ? <RecoveryMessage /> : this.props.children;
  }
}
